import { createStructuredSelector } from 'reselect'
import {
  MGMT_PROJECT_LIST, MGMT_PROJECT_LIST_SUCCESS, MGMT_PROJECT_LIST_ERROR,
  MGMT_PROJECT_PAGE_SET, MGMT_PROJECT_ADD, MGMT_PROJECT_ADD_SUCCESS,
  MGMT_PROJECT_ADD_ERROR, MGMT_PROJECT_ADD_CHANGE, MGMT_PROJECT_DETAIL,
  MGMT_PROJECT_DETAIL_SUCCESS, MGMT_PROJECT_DETAIL_ERROR, MGMT_PROJECT_UPDATE,
  MGMT_PROJECT_UPDATE_SUCCESS, MGMT_PROJECT_UPDATE_ERROR,
} from '../../actions';

export const NAME = 'mgmt_project';

export const MgmtProjectList = (page, num_page, orderBy, filters) => ({ type: MGMT_PROJECT_LIST, payload: { page, num_page, orderBy, filters } });
export const MgmtProjectListSuccess = (data) => ({ type: MGMT_PROJECT_LIST_SUCCESS, payload: data });
export const MgmtProjectListError = (error) => ({ type: MGMT_PROJECT_LIST_ERROR, payload: error });
export const MgmtProjectPageSet = (data) => ({ type: MGMT_PROJECT_PAGE_SET, payload: data });
export const MgmtProjectAddChangeSet = (data) => ({ type: MGMT_PROJECT_ADD_CHANGE, payload: data });
export const MgmtProjectAdd = (data) => ({ type: MGMT_PROJECT_ADD, payload: data });
export const MgmtProjectAddSuccess = (message) => ({ type: MGMT_PROJECT_ADD_SUCCESS, payload: message });
export const MgmtProjectAddError = (error) => ({ type: MGMT_PROJECT_ADD_ERROR, payload: error });
export const MgmtProjectDetail = (data) => ({ type: MGMT_PROJECT_DETAIL, payload: data });
export const MgmtProjectDetailSuccess = (data) => ({ type: MGMT_PROJECT_DETAIL_SUCCESS, payload: data });
export const MgmtProjectDetailError = (error) => ({ type: MGMT_PROJECT_DETAIL_ERROR, payload: error });
export const MgmtProjectUpdate = (data) => ({ type: MGMT_PROJECT_UPDATE, payload: data });
export const MgmtProjectUpdateSuccess = (message) => ({ type: MGMT_PROJECT_UPDATE_SUCCESS, payload: message.message });
export const MgmtProjectUpdateError = (error) => ({ type: MGMT_PROJECT_UPDATE_ERROR, payload: error });

const mgmt_project = (state) => state[NAME];
export const MgmtProjectSelector = createStructuredSelector({ mgmt_project });
